import isEmpty from "lodash/isEmpty";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Grid } from "semantic-ui-react";
import "./inputText.scss";
import { InputTextTypes } from "./InputTypes";

export const InputText = forwardRef<HandleValidation, InputTextTypes>(
  (
    {
      computer,
      tablet,
      mobile,
      name,
      register = () => {},
      errors,
      required = false,
      placeholder,
      labelName,
      errorMessage = "This field is required",
      customLabelText = "",
      customGridMain = "",
      customGridColumn = "",
      customText = "",
      customErrorText = "",
      emptyCheck,
      availableValueCheck,
      checkValue = false,
      defaultValues,
      validateHandle = () => {},
      disabled = false,
      pattern,
      onChangeFunction = () => {},
      onFocus = () => {},
      onBlur = () => {},
      customInputValidation = false,
      type = "text",
      valueAsNumber = false,
      minNumber = -1000,
      step,
      id,
      customRequired = false,
      rightContentEnable = false,
      rightContent = "",
      enableRightTitle = false,
      rightTitle = "",
      customRightLabelText,
      rightContentClick = () => {},
      customTitleGridMain,
      maxLength,
      testId
    },
    ref
  ) => {
    const [customValidation, setCustomValidation] = useState(false);

    useImperativeHandle(ref, () => ({
      checkCustomRequired(data: any) {
        setCustomValidation(isEmpty(data) && customRequired);
      }
    }));

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (
        valueAsNumber &&
        e.target.value.charAt(0) === "0" &&
        e.target.value.length > 1 &&
        e.target.value[1] !== "."
      ) {
        e.target.value = e.target.value.slice(1);
      }
      onChangeFunction(e);
    };

    const hasError = errors || customValidation;
    const errorClass = hasError
      ? customValidation
        ? "textInputFormCustomError"
        : "textInputFormError"
      : "textInputFormText";
    const errorTextClass = hasError
      ? customValidation
        ? "textInputCustomError"
        : "textInputError"
      : "";

    const errorMessageText =
      customValidation && customRequired ? errorMessage : errors?.message || errorMessage;

    return (
      <>
        {labelName || enableRightTitle ? (
          <Grid className={`${customTitleGridMain}`}>
            <Grid.Column computer={enableRightTitle ? 8 : 16}>
              <label data-testid={testId?`${testId}-label`:""} className={`inputTextLable ${customLabelText}`}>{labelName}</label>
            </Grid.Column>
            {enableRightTitle ? (
              <Grid.Column
                computer={8}
                className="rightTextContent"
                onClick={() => rightContentClick()}
              >
                <label className={`rightInputTextLable ${customRightLabelText}`}>
                  {rightTitle}
                </label>
              </Grid.Column>
            ) : null}
          </Grid>
        ) : null}
        <Grid className={`${customGridMain} mt-0`}>
          <Grid.Column
            computer={computer}
            tablet={tablet}
            mobile={mobile}
            className={`inputTextContanier ${customGridColumn} pt-0`}
          >
            <div className="inputWrapper">
              {(checkValue ? availableValueCheck || isEmpty(emptyCheck) : true) && (
                <input
                  id={id}
                  data-testid={testId ? `${testId}` : customText}
                  className={`${errorClass} ${customText} ${
                    rightContentEnable ? "customInputDataView" : ""
                  }`}
                  autoComplete="off"
                  placeholder={placeholder}
                  defaultValue={defaultValues}
                  disabled={disabled}
                  {...register(name, {
                    onChange: handleOnChange,
                    required,
                    validate: validateHandle,
                    valueAsNumber
                  })}
                  onFocus={onFocus}
                  onBlur={onBlur}
                  pattern={pattern}
                  type={type}
                  min={minNumber}
                  step={step}
                  maxLength={maxLength}
                />
              )}
              {rightContentEnable && (
                <div className="inputRightContent">
                  <p className="rightContentText">{rightContent}</p>
                </div>
              )}
            </div>

            {hasError && (
              <span data-testid = {testId? `${testId}-error`:""} className={`${errorTextClass} ${customErrorText}`}>{errorMessageText}</span>
            )}
          </Grid.Column>
        </Grid>
      </>
    );
  }
);
